import React from 'react';

const CheckIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
    <path
      d="M2 6l3 3 5-5"
      stroke="#ffffff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const MultiSelectGrid = ({ options, value = [], onChange }) => {
  const toggle = (option) => {
    if (value.includes(option)) {
      onChange(value.filter((v) => v !== option));
    } else {
      onChange([...value, option]);
    }
  };

  return (
    <div className="ef-multi-grid">
      {options.map((option) => {
        const selected = value.includes(option);
        return (
          <button
            key={option}
            type="button"
            className={['ef-multi-option', selected ? 'ef-multi-option--selected' : '']
              .filter(Boolean)
              .join(' ')}
            onClick={() => toggle(option)}
            aria-pressed={selected}
          >
            <span className="ef-multi-option__checkbox">
              {selected && <CheckIcon />}
            </span>
            <span className="ef-multi-option__label">{option}</span>
          </button>
        );
      })}
    </div>
  );
};

export default MultiSelectGrid;
